export default __webpack_public_path__ + "static/media/logout_icon.b7c27d59.svg";